import { AccountId, ApiResponse, SupplementalData, TaxDocumentList, TaxYearRequest } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getTaxDocumentsForYear = async (accountId: AccountId, year: number) => {
  const response = await api.get<ApiResponse<TaxDocumentList>>(`/users/accounts/${accountId}/tax-years/${year}`);

  return unwrapApiResponse(response.data);
};

export const getAllTaxDocuments = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<TaxDocumentList>>(`/users/accounts/${accountId}/tax-years`);

  return unwrapApiResponse(response.data);
};

export const getSupplementalData = async (accountId: AccountId, year: number) => {
  const response = await api.get<ApiResponse<SupplementalData>>(
    `/users/accounts/${accountId}/tax-years/${year}/offering-breakdown`
  );

  return unwrapApiResponse(response.data);
};

export const patchReitDemandLetterAcknowledgement = async ({
  reitDemandLetterIsAcknowledged,
  accountId,
  year,
}: TaxYearRequest) => {
  const response = await api.patch<ApiResponse<TaxDocumentList>>(`/users/accounts/${accountId}/tax-years/${year}`, {
    reitDemandLetterIsAcknowledged,
  });

  return unwrapApiResponse(response.data);
};
